import { JSX } from 'react'

import { IconProps } from '../../icon'

const Save: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M38.3754 15.5159L30.6297 9.05025C29.8256 8.37743 28.7918 8 27.7415 8H12.5128C10.0185 8 8 10.0185 8 12.5128V35.4872C8 37.9815 10.0185 40 12.5128 40H35.4872C37.9815 40 40 37.9815 40 35.4872V18.9949C40 17.6492 39.4092 16.3856 38.3754 15.5323V15.5159ZM26.0513 10.4779V15.8113C26.0513 16.9436 25.1323 17.8626 24 17.8626H17.4359C16.3036 17.8626 15.3846 16.9436 15.3846 15.8113V10.4779H26.0513ZM15.3846 37.5549V30.5805C15.3846 29.4482 16.3036 28.5292 17.4359 28.5292H30.5641C31.6964 28.5292 32.6154 29.4482 32.6154 30.5805V37.5549H15.3846ZM37.5385 35.5036C37.5385 36.6359 36.6195 37.5549 35.4872 37.5549H35.0769V30.5805C35.0769 28.0862 33.0585 26.0677 30.5641 26.0677H17.4359C14.9415 26.0677 12.9231 28.0862 12.9231 30.5805V37.5549H12.5128C11.3805 37.5549 10.4615 36.6359 10.4615 35.5036V12.5292C10.4615 11.3969 11.3805 10.4779 12.5128 10.4779H12.9231V15.8113C12.9231 18.3056 14.9415 20.3241 17.4359 20.3241H24C26.4944 20.3241 28.5128 18.3056 28.5128 15.8113V10.642C28.7097 10.7241 28.8903 10.8226 29.0544 10.9538L36.8 17.4195C37.2759 17.8133 37.5385 18.3877 37.5385 18.9949V35.5036Z'
      fill='black'
    />
  </svg>
)

export default Save
